import z from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { validateJSONSchema } from 'utils/json'
import { RichPlacementMultiAnchor } from '../../hooks/useGetRichPlacementMultiAnchor'

export const schema = z.object({
  customStyling: z.string().superRefine(validateJSONSchema),
  displayAfterUserInteraction: z.boolean().default(false),
  fullWidthMode: z.boolean().default(false),
  showCloseButton: z.boolean().default(false),
  singleAdViewTime: z.number().min(2_000).max(MAX_SAFE_GQL_INTEGER).default(5_000),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (multiAnchor: RichPlacementMultiAnchor): Schema => {
  const {
    customStyling,
    displayAfterUserInteraction,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  } = multiAnchor

  return {
    customStyling,
    displayAfterUserInteraction,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  }
}
